import React, {ReactNode} from 'react';
import { LocalizationProvider, TimePicker} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {Formats} from "../constants/Formats";
import dayjs, {Dayjs} from "dayjs";

type FormFieldTimeProps = {
    label: string;
    value: Dayjs;
    minTime?: Dayjs;
    maxTime?: Dayjs;
    type?: string;
    required?: boolean;
    disabled?: boolean;
    errorText?: string;
    onChange?: (value: string) => void;
};

const FormFieldTime: React.FC<FormFieldTimeProps> = (props) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
                label={props.label}
                format={Formats.TIME_COLON}
                minTime={props.minTime}
                maxTime={props.maxTime}
                value={props.value}
                onChange={(data) => {
                    props.onChange && props.onChange(dayjs(data).format(Formats.TIME_SIMPLE))
                }}
                slotProps={{
                    textField: {
                        required: props.required,
                        variant: 'standard',
                        margin: "normal",
                        fullWidth: true,
                        helperText: props.errorText,
                        error: (props.errorText !== undefined && props.errorText !== '')
                    }
                }}
            />
        </LocalizationProvider>
    );
};
export default FormFieldTime;